import { orderRepository } from '../repositories/order-repository';

async function buyUpsell(subscriptionId, productId) {
    if (!subscriptionId) {
        throw Error('Invalid subscriptionId parameter');
    }

    if (!productId) {
        throw Error('Invalid productId parameter');
    }

    return orderRepository.buyUpsell({ subscriptionId, productId });
}

export {
    buyUpsell
};
